export { initGa4 }

// see: https://developers.google.com/analytics/devguides/migration/ua/analyticsjs-to-gtagjs
const initGa4 = token => {
  /* global gtag */
  gtag('js', new Date());
  gtag('config', token);
}